import React from "react";

const Index = () => {
  return (
    <div className="bg-light py-5">
      <div className="container my-4 my-md-5 text-left">
        <div className="small-container">
          <p className="fs-4 mb-3 fs-large fw-medium">Get in touch</p>
          <h2 className="fw-normal fw-1 fs-extra-large pb-5">
            Don't be shy, <br />
            say hello.
          </h2>

          <p className="fs-1 fw-normal pt-5 pb-5 mb-5">
            Thank you for visiting! Whether you have a question, comment, or
            simply want to say hello, I encourage you to reach out. I'm here to
            assist and love connecting with my community, so don't hesitate to
            get in touch.
          </p>

          <div>
            <a
              className="text-black fs-extra-large text-decoration-none fw-light"
              href="tel:+918077616404"
            >
              +91 80776 16404
            </a>

            <br />
            <br />

            <a
              className="text-black fs-extra-large fw-light"
              href="mailto:hi@hanzala.co.in"
            >
              hi@hanzala.co.in
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
